import type { HomePage } from '../model/HomePage';

export const BuisnessUser: HomePage = {
    name: 'BuisnessUser',
    widgets: [ 'RecommendationTemplates', 'Apps', 'Automations', 'Runs', 'Actions' ],
    featureFlag: 'HomePage-BuisnessUser',
    persona: 'BUSINESS_USER',
};
